module.exports = __webpack_public_path__ + "static/media/Trumpets8s.289d2da1.mp3";